/*
  nsi-trade-live.js — swaps the site's trade furniture the instant a customer's state
  changes, without a page reload.

  Why it exists: the header badge and the announcement bar are rendered server-side from
  customer.tags. When someone verifies their ABN on /pages/add-abn, or switches back to
  retail from /pages/trade, the tag changes in Shopify but the page they are looking at
  still shows the old state. They finish the ABN and the header keeps saying "Add ABN",
  which reads as though nothing happened.

  Both bars are rendered by Liquid up front (the non-matching one carries `hidden`), so
  this file only ever moves a `hidden` attribute and rewrites the badge in place. It never
  builds copy of its own: the member wording comes off data-nsi-active-* attributes, which
  are theme settings, so the customizer stays the single source of the words.

  Use:
      window.NSITradeLive.set('active');   // ABN verified, they are a trade member now
      window.NSITradeLive.set('none');     // switched back to a retail account

  Either call also fires a `nsi:trade-state` event on document, so any section can react
  (the trade page listens for it to swap its own pending band).
*/
(function () {
  'use strict';

  // The announcement section renders up to three bars for a pending customer (amber pending
  // visible, purple member and the retail banner hidden). Verifying should land on the member
  // bar; switching back to retail should land on the retail banner. Either bar can be absent
  // (its own enable switch is off, or the retail banner is homepage-only), so both fall back.
  function swapAnnouncement(prefer) {
    var pending = document.querySelector('[data-nsi-announce="pending"]');
    var trade = document.querySelector('[data-nsi-announce="trade"]');
    var retail = document.querySelector('[data-nsi-announce="retail"]');
    if (pending) pending.hidden = true;
    if (prefer === 'trade') {
      if (trade) { trade.hidden = false; return; }
    } else if (trade) {
      trade.hidden = true;
    }
    if (retail) retail.hidden = false;
  }

  function badgeToActive(el) {
    var short = el.getAttribute('data-nsi-active-short') || 'Trade Active';
    var long = el.getAttribute('data-nsi-active-long') || 'Trade Prices Active';
    el.classList.remove('nsi-trade-badge--abn');
    el.classList.add('nsi-trade-badge--active');
    el.setAttribute('href', el.getAttribute('data-nsi-active-href') || '/pages/trade');
    el.setAttribute('data-nsi-trade-badge', 'active');

    // Rebuilt with DOM nodes, not innerHTML: the labels are customizer settings.
    while (el.firstChild) el.removeChild(el.firstChild);
    var dot = document.createElement('span');
    dot.className = 'nsi-trade-badge-dot';
    el.appendChild(dot);
    var s = document.createElement('span');
    s.className = 'nsi-trade-badge-label--short';
    s.textContent = short;
    el.appendChild(s);
    var l = document.createElement('span');
    l.className = 'nsi-trade-badge-label--long';
    l.textContent = long;
    el.appendChild(l);
  }

  function set(state) {
    var badge = document.querySelector('[data-nsi-trade-badge]');
    if (state === 'active') {
      if (badge && badge.getAttribute('data-nsi-trade-badge') === 'pending') badgeToActive(badge);
      swapAnnouncement('trade');
    } else if (state === 'none') {
      // A signed-in retail customer carries no badge at all, so remove it rather than
      // trying to render a state the header has no markup for.
      if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
      swapAnnouncement('retail');
    }
    try {
      document.dispatchEvent(new CustomEvent('nsi:trade-state-applied', { detail: { state: state } }));
    } catch (e) {}
  }

  window.NSITradeLive = { set: set };

  document.addEventListener('nsi:trade-state', function (e) {
    set(e && e.detail && e.detail.state);
  });
})();
